(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  var fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency });
  var money = function (c) { return fmt.format(c / 100); };
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* toast */
  var toastEl = $('#hb-toast'), toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2200);
  }

  /* drawers */
  var scrim = $('#hb-scrim');
  function openDrawer(d) { if (!d) return; d.classList.add('is-open'); scrim && scrim.classList.add('is-on'); d.setAttribute('aria-hidden', 'false'); var f = $('button,a', d); f && f.focus(); }
  function closeAll() { $$('.drawer').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); }); scrim && scrim.classList.remove('is-on'); }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  scrim && scrim.addEventListener('click', closeAll);
  $$('[data-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
  var menuBtn = $('#hb-menu-btn'); menuBtn && menuBtn.addEventListener('click', function () { openDrawer($('#hb-menu')); });

  /* cart */
  var bagDrawer = $('#hb-bag');
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); }); }
  function renderCart(cart) {
    setCount(cart.item_count);
    var list = $('#hb-bag-items'); if (!list) return;
    if (!cart.items.length) {
      list.innerHTML = '<p class="bag-empty">Your bag is empty.<br><a href="' + root + 'collections/all">Start shopping</a></p>';
    } else {
      list.innerHTML = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + esc(it.image) + '&width=160" alt="" width="64" height="64">' : '<div class="ph-sm"></div>';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) + ' · ' : '';
        var props = '';
        if (it.properties) Object.keys(it.properties).forEach(function (k) { if (k.charAt(0) !== '_' && it.properties[k]) props += '<small>' + esc(k) + ': ' + esc(it.properties[k]) + '</small>'; });
        return '<div class="bag-row">' + img + '<div><h4>' + esc(it.product_title) + '</h4><small>' + variant + money(it.final_line_price) + '</small>' + props + '</div>' +
          '<div class="qty"><button type="button" data-line="' + it.key + '" data-q="' + (it.quantity - 1) + '" aria-label="Remove one">−</button><span>' + it.quantity + '</span><button type="button" data-line="' + it.key + '" data-q="' + (it.quantity + 1) + '" aria-label="Add one">+</button></div></div>';
      }).join('');
    }
    var sub = $('#hb-subtotal'); if (sub) sub.textContent = money(cart.total_price);
    var co = $('#hb-checkout'); if (co) co.disabled = !cart.items.length;
  }
  function fetchCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {}); }
  function addToCart(body) {
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); return j; }); })
      .then(function () { return fetchCart(); })
      .then(function () { openDrawer(bagDrawer); });
  }
  document.addEventListener('click', function (e) {
    var line = e.target.closest('[data-line]');
    if (line) {
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.getAttribute('data-line'), quantity: Math.max(0, +line.getAttribute('data-q')) }) })
        .then(function (r) { return r.json(); }).then(renderCart).catch(function () { toast('Something went wrong. Please try again.'); });
      return;
    }
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      var fd = new FormData(); fd.append('id', quick.getAttribute('data-quick-add')); fd.append('quantity', 1);
      quick.setAttribute('aria-busy', 'true');
      addToCart(fd).catch(function (err) { toast(err.message); }).then(function () { quick.removeAttribute('aria-busy'); });
      return;
    }
    var bagBtn = e.target.closest('[data-open-bag]');
    if (bagBtn && bagDrawer) { e.preventDefault(); fetchCart(); openDrawer(bagDrawer); }
  });
  var co = $('#hb-checkout'); co && co.addEventListener('click', function () { window.location.href = root + 'checkout'; });

  /* product page */
  $$('[data-product]').forEach(function (wrap) {
    var dataEl = $('[data-variants]', wrap); if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = $('form[data-product-form]', wrap);
    var idInput = $('input[name="id"]', form);
    var priceEl = $('[data-price]', wrap), btn = $('[data-add-btn]', wrap), mainImg = $('[data-main-img]', wrap), nut = $('[data-nut]', wrap);
    function apply(v) {
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = (v.compare && v.compare > v.price ? '<s>' + money(v.compare) + '</s>' : '') + money(v.price);
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.getAttribute('data-label') : 'Sold out'; }
      if (v.image && mainImg) { mainImg.src = v.image; mainImg.removeAttribute('srcset'); }
      if (nut) {
        var has = v.kcal || v.protein || v.carbs || v.fat;
        nut.hidden = !has;
        if (has) { $('[data-n="kcal"]', nut).textContent = v.kcal ? v.kcal + ' kcal' : '–'; $('[data-n="protein"]', nut).textContent = v.protein ? v.protein + 'g' : '–'; $('[data-n="carbs"]', nut).textContent = v.carbs ? v.carbs + 'g' : '–'; $('[data-n="fat"]', nut).textContent = v.fat ? v.fat + 'g' : '–'; }
      }
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
    }
    $$('input[name="hb-variant"]', wrap).forEach(function (r) {
      r.addEventListener('change', function () { apply(variants.filter(function (v) { return String(v.id) === r.value; })[0]); });
    });
    $$('[data-thumb]', wrap).forEach(function (t) {
      t.addEventListener('click', function () { mainImg.src = t.getAttribute('data-thumb'); mainImg.removeAttribute('srcset'); $$('[data-thumb]', wrap).forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); }); });
    });
    $$('[data-step]', wrap).forEach(function (b) {
      b.addEventListener('click', function () { var q = $('input[name="quantity"]', form); q.value = Math.max(1, (+q.value || 1) + +b.getAttribute('data-step')); });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = $('[data-error]', wrap); if (err) err.hidden = true;
      btn.disabled = true;
      addToCart(new FormData(form)).catch(function (x) { if (err) { err.textContent = x.message; err.hidden = false; } }).then(function () { btn.disabled = false; });
    });
  });


  /* build your own box */
  $$('[data-box]').forEach(function (box) {
    var max = +box.getAttribute('data-max'), min = +box.getAttribute('data-min');
    var items = $$('[data-box-item]', box), counts = items.map(function () { return 0; });
    var form = $('[data-box-form]', box), prop = $('[data-box-prop]', box), addBtn = $('[data-box-add]', box), proxy = $('[data-box-add-proxy]', box);
    if (!form || !prop || !addBtn) return;
    var slots = $$('.slot', box), bar = $('[data-box-bar]', box), hint = $('[data-box-hint]', box), err = $('[data-error]', box);
    function total() { return counts.reduce(function (a, b) { return a + b; }, 0); }
    function render() {
      var t = total(), picks = [];
      items.forEach(function (it, i) {
        $('[data-box-qty]', it).textContent = counts[i];
        $('[data-box-minus]', it).disabled = counts[i] === 0;
        $('[data-box-plus]', it).disabled = t >= max || it.classList.contains('is-out');
        it.classList.toggle('is-picked', counts[i] > 0);
        for (var k = 0; k < counts[i]; k++) picks.push(it);
      });
      slots.forEach(function (s, i) {
        var it = picks[i];
        s.classList.toggle('is-filled', !!it);
        if (it) { var img = it.getAttribute('data-img'), n = it.getAttribute('data-name'); s.innerHTML = img ? '<img src="' + img + '" alt="' + esc(n) + '">' : '<span>' + esc(n.charAt(0)) + '</span>'; s.title = n; }
        else { s.innerHTML = '<span>' + (i + 1) + '</span>'; s.removeAttribute('title'); }
      });
      $$('[data-box-count]', box).forEach(function (c) { c.textContent = t; });
      if (bar) bar.style.width = (t / max * 100) + '%';
      var ok = t >= min && t <= max;
      addBtn.disabled = !ok; if (proxy) proxy.disabled = !ok;
      prop.value = items.map(function (it, i) { return counts[i] ? counts[i] + '× ' + it.getAttribute('data-name') : null; }).filter(Boolean).join(', ');
      if (hint) hint.textContent = t >= max ? 'Your box is full ♡' : (t >= min ? 'Add up to ' + (max - t) + ' more, or add your box to the bag.' : 'Pick ' + (min - t) + ' more to complete your box.');
    }
    items.forEach(function (it, i) {
      $('[data-box-plus]', it).addEventListener('click', function () { if (total() < max) { counts[i]++; render(); } });
      $('[data-box-minus]', it).addEventListener('click', function () { if (counts[i] > 0) { counts[i]--; render(); } });
    });
    var clr = $('[data-box-clear]', box); if (clr) clr.addEventListener('click', function () { counts = counts.map(function () { return 0; }); render(); });
    if (proxy) proxy.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else addBtn.click(); });
    form.addEventListener('submit', function (e) {
      e.preventDefault(); if (err) err.hidden = true;
      if (total() < min) return;
      addBtn.disabled = true;
      addToCart(new FormData(form)).then(function () { counts = counts.map(function () { return 0; }); render(); })
        .catch(function (x) { if (err) { err.textContent = x.message; err.hidden = false; } render(); });
    });
    render();
  });

  /* newsletter success state when redirected back */
  if (/customer_posted=true/.test(location.search)) toast("You're on the Bae List ♡");

  fetchCart();
})();
